import * as React from "react";
import { cn } from "@/lib/utils";

export interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "default" | "narrow";
}

export function Container({ variant = "default", className, ...props }: ContainerProps) {
  return (
    <div
      className={cn("mx-auto w-full", className)}
      style={{
        maxWidth: variant === "narrow" ? "760px" : "1200px",
        paddingInline: "clamp(20px, 5vw, 48px)",
      }}
      {...props}
    />
  );
}

export default Container;
